// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"CustomStyles_textWrapper__n66AE","textQuote":"CustomStyles_textQuote__VWRtH","textAuthor":"CustomStyles_textAuthor__igre2"};